"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactFeather = require("react-feather");
var _CreateChoiceList = _interopRequireDefault(require("./CreateChoiceList"));
var _helpers = require("../../utils/helpers");
var _CustomDataListModule = _interopRequireDefault(require("../../scss/form-elements/CustomDataList.module.scss"));
var _FormModule = _interopRequireDefault(require("../../scss/form-elements/Form.module.scss"));
function CustomDataList({
  name,
  options,
  label = '',
  placeholder = '',
  width = 100,
  multiple = false,
  showValidation = true,
  ...attributes
}) {
  var _inputRef$current, _inputRef$current2, _inputRef$current3;
  const [inputClass, setInputClass] = (0, _react.useState)(`${_FormModule.default['form-field__input']}`);
  const searchInputRef = (0, _react.useRef)();
  const inputRef = (0, _react.useRef)();
  const choicesListRef = (0, _react.useRef)();
  const [validationMessage, setValidationMessage] = (0, _react.useState)('');
  const [validationStatus, setValidationStatus] = (0, _react.useState)('clean');
  const [selections, setSelections] = (0, _react.useState)([]);
  const [choices, setChoices] = (0, _react.useState)([]);
  const [flatChoices, setFlatChoices] = (0, _react.useState)([]);
  const [currentSelected, setCurrentSelected] = (0, _react.useState)(null);
  const [choicesStatus, setChoicesStatus] = (0, _react.useState)('hidden');
  const currentHighlightedIndex = (0, _react.useRef)(-1);
  const widthClass = `input-width--${width}`;
  const keysToWatch = ['Enter', 'Escape', 'ArrowDown', 'ArrowUp'];

  /**
   * Creates a flat array of all the choices to use
   * index look up
   * @param {Array} options The array of options to flatten
   * 
   * @returns {Array} A flat array of choices 
   */
  const createOptionsFlatMap = options => {
    let _choicesFlattened = [];
    const recursiveOptionsFlatMap = options => {
      for (const option of options) {
        if (option.status !== 'filtered') _choicesFlattened.push(option);
        if (option.subcategories.length) recursiveOptionsFlatMap(option.subcategories);
      }
    };
    recursiveOptionsFlatMap(options);
    return _choicesFlattened;
  };

  /**
   * Sets the new status of an item in the list
   * and unsets the status of an item if there should 
   * only be one of the status type in the list
   * @param {Array} list The list to iterate over
   * @param {Number} id The id of the item to update the status of
   * @param {String} [status=selected] The status to apply
   *  
   * @returns {Array} The list of options with updated status
   */
  const setStatus = (list, id, status = 'selected') => {
    if (!multiple && status === 'selected' || status === 'highlighted') {
      for (const item of list) {
        if (item.status === status) {
          item.status = 'active';
          break;
        }
      }
    }
    for (const item of list) {
      if (item.id === id) {
        if (multiple && item.status !== 'selected' && status === 'selected') setSelections([...selections, item]);
        if (item.status !== 'selected') item.status = status;
        if (status === 'selected') {
          setCurrentSelected(item);
          break;
        }
      }
      if (item.subcategories.length) setStatus(item.subcategories, id, status);
    }
    return list;
  };

  /**
   * Creates a colon separated list of the 
   * items hierarchy labels
   * @param {Object} item The item to prepare the display text for
   * 
   * @returns {String} The text to be displayed
   */
  const setDisplayText = item => {
    let labels = [];
    const setLabels = item => {
      if (item.parent_id) {
        labels.unshift(item.label);
        setLabels(options.find(i => i.id === item.parent_id));
      } else {
        labels.unshift(item.label);
      }
      return labels;
    };
    return setLabels(item).join(':');
  };

  /**
   * Run native broswer validation on the select input
   */
  const validate = () => {
    setTimeout(() => {
      if (inputRef.current.checkValidity()) {
        setValidationMessage('');
      } else {
        setValidationMessage(inputRef.current.validationMessage);
      }
    }, 100);
  };

  /**
   * Toggle the display of the choices list
   * when the selection section is clicked
   * @param {Object} e 
   */
  const toggleChoicesView = e => {
    e === null || e === void 0 ? void 0 : e.stopPropagation();
    setValidationStatus('touched');
    setInputClass(`${_FormModule.default['form-field__input']} ${_FormModule.default['input--touched']}`);
    if (choicesStatus === 'hidden') {
      setChoicesStatus('visible');
      searchInputRef.current.focus();
    } else {
      setChoicesStatus('hidden');
      validate();
    }
  };

  /**
   * Removes a choice from the selected list
   * @param {Number} id 
   */
  const removeSelection = id => {
    const _selections = selections;
    const newSelections = _selections.filter(selection => {
      return selection.id !== id;
    });
    setSelections([...newSelections]);
    let _choices = choices;
    const setStatus = (list, id) => {
      for (const item of list) {
        if (item.id === id) {
          item.status = 'active';
          break;
        }
        if (item.subcategories.length) setStatus(item.subcategories, id);
      }
      return list;
    };
    const newChoices = setStatus(_choices, id);
    setChoices([...newChoices]);
    document.querySelector(`select[name="${name}"] > option[value="${id}"]`).selected = false;
  };

  /**
   * Filters the choices list when user inputs
   * text in the search field
   * @param {Object} e 
   * @listens SyntheticBaseEvent:onChange
   */
  const handleFiltering = e => {
    e.stopPropagation();
    if (e.keyCode === 40 || e.keyCode === 38) {
      handleKeyPress(e);
    } else {
      // reset the highlighted index
      currentHighlightedIndex.current = -1;
      const term = e.currentTarget.value;
      const _choices = choices;
      const applyFilter = list => {
        for (const item of list) {
          // if the item contains the term and isn't selected
          if (!item.label.toLowerCase().includes(term.toLowerCase()) && item.status !== 'selected') item.status = 'filtered';
          if (item.subcategories.length) applyFilter(item.subcategories);
        }
        return list;
      };
      const removeAllFilters = list => {
        for (const item of list) {
          if (item.status === 'filtered') item.status = 'active';
          if (item.subcategories.length) removeAllFilters(item.subcategories);
        }
        return list;
      };
      const filteredResults = term === '' ? removeAllFilters(_choices) : applyFilter(_choices);
      setChoices([...filteredResults]);
      setFlatChoices([...createOptionsFlatMap(filteredResults)]);
    }
  };

  /**
   * Set choice as selected when clicked
   * @param {Object} e
   * @listens SyntheticBaseEvent:onClick
   */
  const handleSelected = selectedId => {
    const _choices = structuredClone(choices);
    const newChoices = setStatus(_choices, selectedId);
    setChoices([...newChoices]);
    toggleChoicesView(null);
    // set the selected attr on the real select input
    document.querySelector(`select[name="${name}"] > option[value="${selectedId}"]`).selected = true;
  };

  /**
   * Allow keyboard navigation of choices list
   * @listens SyntheticBaseEvent:onKeyDown
   * @param {Object} e
   *   
   * @returns {Boolean} Returns false if key pressed 
   * wasn't arrow up, arrow down, or return 
   */
  const handleKeyPress = e => {
    e.stopPropagation();
    e.preventDefault();
    const key = e.key;
    const _choices = choices;
    const changeHighlightedOption = index => {
      const optionId = flatChoices[index].id;
      const newChoices = setStatus(_choices, optionId, 'highlighted');
      setChoices([...newChoices]);
    };
    if (key === 'ArrowDown' && choicesStatus === 'visible') {
      // arrow down pressed
      if (currentHighlightedIndex.current < flatChoices.length - 1) {
        changeHighlightedOption(currentHighlightedIndex.current + 1);
        currentHighlightedIndex.current++;
      } else {
        // if at the end go back to top of list
        changeHighlightedOption(0);
        currentHighlightedIndex.current = 0;
      }
    } else if (key === 'ArrowUp' && choicesStatus === 'visible') {
      // arrow up pressed
      if (currentHighlightedIndex.current > 0) {
        changeHighlightedOption(currentHighlightedIndex.current - 1);
        currentHighlightedIndex.current--;
      } else {
        // if at the top go down to end of list
        changeHighlightedOption(flatChoices.length - 1);
        currentHighlightedIndex.current = flatChoices.length - 1;
      }
    } else if (key === 'Enter') {
      // return key was pressed
      if (choicesStatus === 'visible' && currentHighlightedIndex !== -1) {
        const selectedId = flatChoices[currentHighlightedIndex.current].id;
        const newChoices = setStatus(_choices, selectedId);
        setChoices([...newChoices]);
        toggleChoicesView();
        // set the selected attr in the real select input
        document.querySelector(`select[name="${name}"] > option[value="${selectedId}"]`).selected = true;
      } else {
        toggleChoicesView();
      }
    } else if (key === 'Escape' && choicesStatus === 'visible') {
      toggleChoicesView();
      currentHighlightedIndex.current = -1;
    } else {
      return false;
    }
    // scroll choices list so that highlighted item is in view
    if (30 * currentHighlightedIndex.current > 160) {
      choicesListRef.current.scrollTo(0, 30 * currentHighlightedIndex.current);
    } else {
      choicesListRef.current.scrollTo(0, 0);
    }
  };
  (0, _react.useEffect)(() => {
    // init all options
    let withSubCats = options.map(option => {
      return {
        ...option,
        subcategories: [],
        status: 'active'
      };
    });
    // fill subcatagory trees
    for (const option of withSubCats) {
      if (Number.parseInt(option.parent_id, 10)) {
        let parentOption = withSubCats.find(o => {
          return o.id === option.parent_id;
        });
        if (parentOption) parentOption.subcategories.push(option);
      }
    }
    // leave top level items only (they now include subcat trees)
    const _choices = withSubCats.filter(option => {
      return option.parent_id === null;
    });
    // create a falt array of options for index referencing
    setFlatChoices(createOptionsFlatMap(_choices));
    setChoices(_choices);
  }, [options]);
  return /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: name,
    className: (0, _helpers.classes)([_FormModule.default['form-field'], _FormModule.default[widthClass]])
  }, showValidation && /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _helpers.classes)([_FormModule.default['form-field__icon'], (_inputRef$current = inputRef.current) !== null && _inputRef$current !== void 0 && _inputRef$current.validity.valid ? '' : _FormModule.default['form-field__icon--invalid']]),
    style: label === '' ? {
      top: '0.4em'
    } : {}
  }, ((_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.checkValidity()) && validationStatus === 'touched' && /*#__PURE__*/_react.default.createElement(_reactFeather.CheckCircle, null), !((_inputRef$current3 = inputRef.current) !== null && _inputRef$current3 !== void 0 && _inputRef$current3.checkValidity()) && validationStatus === 'touched' && /*#__PURE__*/_react.default.createElement(_reactFeather.AlertTriangle, null)), /*#__PURE__*/_react.default.createElement("span", {
    className: _FormModule.default['form-field__label']
  }, label), /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({
    name: name,
    className: (0, _helpers.classes)([_CustomDataListModule.default['custom-data-list__select'], validationStatus === 'touched' ? _CustomDataListModule.default['custom-data-list__select--touched'] : '']),
    multiple: multiple,
    ref: inputRef
  }, attributes), /*#__PURE__*/_react.default.createElement("option", {
    value: ""
  }), options.length && options.map(option => {
    return /*#__PURE__*/_react.default.createElement("option", {
      value: option.id,
      selected: option.selected,
      key: `option-${option.id}`
    }, option.label);
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([inputClass, _CustomDataListModule.default['custom-data-list'], 'custom-data-list'])
  }, multiple && /*#__PURE__*/_react.default.createElement("ul", {
    className: `${_CustomDataListModule.default['custom-data-list__selections']}`,
    onClick: toggleChoicesView
  }, selections.length !== 0 && selections.map(selection => {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: _CustomDataListModule.default['custom-data-list__selected'],
      key: `selection-${selection.id}`
    }, setDisplayText(selection), /*#__PURE__*/_react.default.createElement("button", {
      title: "remove",
      type: "button",
      className: _CustomDataListModule.default['custom-data-list__remove'],
      onClick: e => {
        e.stopPropagation();
        removeSelection(selection.id);
      }
    }, /*#__PURE__*/_react.default.createElement(_reactFeather.X, {
      width: 16,
      height: 16
    })));
  }), selections.length === 0 && placeholder !== '' && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _helpers.classes)([_CustomDataListModule.default['custom-data-list__placeholder'], 'custom-data-list__placeholder'])
  }, placeholder)), !multiple && /*#__PURE__*/_react.default.createElement("div", {
    className: _CustomDataListModule.default['custom-data-list__selection'],
    onClick: toggleChoicesView
  }, currentSelected && setDisplayText(currentSelected), !currentSelected && placeholder !== '' && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _helpers.classes)([_CustomDataListModule.default['custom-data-list__placeholder'], 'custom-data-list__placeholder'])
  }, placeholder)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_CustomDataListModule.default['custom-data-list__choices-wrapper'], choicesStatus === 'visible' ? '' : _CustomDataListModule.default['custom-data-list__choices-wrapper--hidden']])
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _CustomDataListModule.default['custom-data-list__filter-wrap']
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    ref: searchInputRef,
    onChange: handleFiltering,
    onKeyDown: e => {
      if (keysToWatch.includes(e.key)) {
        handleKeyPress(e);
      } else {
        return true;
      }
    },
    className: _CustomDataListModule.default['custom-data-list__filter']
  }), /*#__PURE__*/_react.default.createElement("i", {
    className: _CustomDataListModule.default['custom-data-list__filter-icon']
  }, /*#__PURE__*/_react.default.createElement(_reactFeather.Search, {
    width: 14,
    height: 14
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _CustomDataListModule.default['custom-data-list__choices'],
    ref: choicesListRef,
    onKeyDown: handleKeyPress
  }, choices.length !== 0 && /*#__PURE__*/_react.default.createElement(_CreateChoiceList.default, {
    list: choices,
    handleOnClick: handleSelected
  }))), /*#__PURE__*/_react.default.createElement("i", {
    className: _CustomDataListModule.default['custom-data-list__icon']
  }, /*#__PURE__*/_react.default.createElement(_reactFeather.Triangle, null))), validationMessage !== '' && showValidation && /*#__PURE__*/_react.default.createElement("div", {
    className: _FormModule.default['form-field__error-message']
  }, validationMessage));
}
var _default = exports.default = CustomDataList;